<template>
  <form-group :for-id="id" :label="label" :required="required"
              :validation-errors="validationErrors">
    <input :id="id"
           :name="name"
           ref="gi"
           class="form-control"
           :class="{'has-error':validationErrors && validationErrors.length > 0}"
           :value="modelValue"
           :required="required"
           :disabled="disabled"
           :type="type"
           @input="updateValue($event)"
           @keydown="$emit('keydown',$event)"
           @keyup="$emit('keyup',$event)"
           :placeholder="placeholder"
           :autocomplete="autocomplete"/>

    <template v-slot:after>
      <slot name="after"/>
    </template>

  </form-group>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';
import { ErrorObject } from '@vuelidate/core';
import FormGroup from '@/components/ui/FormGroup.vue';

export default defineComponent({
  name: 'GroupInput',
  components: { FormGroup },
  emits: ['update:modelValue', 'keydown', 'keyup'],
  props: {
    id: String,
    name: String,
    modelValue: String,
    required: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    type: { type: String, default: 'text' },
    label: String,
    placeholder: String,
    autocomplete: String,
    autofocus: { type: Boolean, default: false },
    validationErrors: Object as PropType<ErrorObject[]>,
  },
  methods: {
    updateValue(e: Event) {
      this.$emit('update:modelValue', (<HTMLInputElement>e.target).value);
    },
    focusInput() {
      (this.$refs.gi as HTMLInputElement).focus();
    }
  },
  mounted() {
    if (this.$props.autofocus) {
      this.$nextTick(() => {
        this.focusInput();
      });
    }
  }
});
</script>

<style scoped>
</style>
